import { supabase } from '../lib/supabase';
import { Coach } from '../types/Coach';

export async function fetchCoaches(): Promise<Coach[]> {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, first_name, last_name, role')
    .in('role', ['coach', 'administrator']);
  if (error) {
    console.error('Error fetching coaches:', error.message);
    return [];
  }
  return data.map((profile: any) => ({
    id: profile.id,
    name: `${profile.first_name || ''} ${profile.last_name || ''}`.trim(),
    email: profile.email,
    avatarUrl: '' // You can add logic for avatar URL if available
  }));
}